import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import io from 'socket.io-client';
import Loading from '../components/loading';
import * as api from '../service/api'


function Ativar() {
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const [codigo, setCodigo] = useState("")
    const [erroCodigo, setErroCodigo] = useState(null)
    const [feedback, setFeedback] = useState(null)
    const [socket, setSocket] = useState(null)

    useEffect(() => {
        // let socket = io(api.SOCKET_FLUSSONIC)
        // setSocket(socket)
        // console.log(socket)

        return () => {
            // socket.disconnect()
        }
    }, [])

    const getFeedback = (tipo, msg) => {
        switch (tipo) {
            case 'success':
                return (
                    <div className="w-full bg-green-600 bg-opacity-20 border border-green-600 rounded-lg relative p-3 mb-4">
                        <button className="absolute top-2 right-3 text-green-400 hover:text-white text-lg" type="button" onClick={() => { setFeedback(null) }}>
                            <span>&times;</span>
                        </button>
                        <span className="text-green-400 text-sm">{msg}</span>
                    </div>
                )
            case 'error':
                return (
                    <div className="w-full bg-red-600 bg-opacity-20 border border-red-600 rounded-lg relative p-3 mb-4">
                        <button className="absolute top-2 right-3 text-red-400 hover:text-white text-lg" type="button" onClick={() => { setFeedback(null) }}>
                            <span>&times;</span>
                        </button>
                        <span className="text-red-400 text-sm">{msg}</span>
                    </div>
                )
        }
    }

    const ativarDispositivo = () => {
        if (codigo.length < 6) {
            setErroCodigo('Código deve ter 6 caracteres')
            return;
        }

        setLoading(true)
        setTimeout(() => {
            api.ativarDispositivo(codigo.toLowerCase())
                .then(res => {
                    setLoading(false)
                    if (!res.success) {
                        if (res.code == 0) {
                            history.replace('/logout')
                        } else {
                            setFeedback(getFeedback('error', res.message))
                        }
                        return
                    }
                    let socket = io(api.SOCKET_FLUSSONIC)
                    socket.on('connect', () => {
                        socket.emit('activation', res)
                        setFeedback(getFeedback('success', 'Dispositivo ativado'))
                        setCodigo('')
                        setTimeout(() => {
                            history.replace('/app/device_manager')
                            socket.disconnect()
                        }, 1500);
                    })

                })
        }, 500);
    }

    const onChange = (e) => {
        if (e.target.value.length >= 7) {
            e.preventDefault()
            return
        }
        setCodigo(e.target.value)
    }

    return (
        <div className="container mx-auto pt-10 pb-16 px-4 max-w-2xl">
            <h1 className="text-3xl font-bold">Ativar dispositivo</h1>
            <p className="text-sm text-gray-400 mt-1">Insira o código exibido no seu aparelho para ativá-lo</p>
            <hr className="border-orange-700 mt-3 mb-6" />
            {loading ? <Loading /> : (
                <>
                    {feedback}
                    <div className="bg-gray-800 border border-gray-700 rounded-lg p-6 flex flex-col gap-4">
                        <div>
                            <label className="block text-sm text-gray-400 mb-1">Código do dispositivo</label>
                            <input
                                required
                                type="text"
                                minLength='6'
                                maxLength="6"
                                value={codigo}
                                className="p-2 rounded uppercase text-black w-full max-w-xs tracking-widest text-lg font-mono"
                                onChange={onChange}
                                placeholder="000000"
                            />
                            {erroCodigo && <p className="text-red-500 text-sm mt-1">{erroCodigo}</p>}
                        </div>
                        <div className="flex gap-3">
                            <button onClick={() => ativarDispositivo()} className="bg-orange-600 hover:bg-orange-700 px-6 py-2 rounded font-semibold text-white">Ativar</button>
                            <Link to="/app/account"><button type="button" className="bg-gray-700 hover:bg-gray-600 px-6 py-2 rounded text-white">Cancelar</button></Link>
                        </div>
                    </div>

                    <div className="mt-5 bg-gray-800 border border-gray-700 rounded-lg p-5">
                        <p className="text-sm font-semibold text-gray-300 mb-3">Instruções</p>
                        <ul className="flex flex-col gap-2 text-sm text-gray-400 list-disc list-inside">
                            <li>Siga as instruções no seu aparelho para ativar seu dispositivo</li>
                            <li>Certifique-se que seu aparelho esteja conectado</li>
                            <li>O código gerado pelo dispositivo tem duração máxima de <span className="text-white font-medium">10 minutos</span></li>
                            <li>
                                Caso tenha atingido o limite de dispositivos, remova um em{' '}
                                <Link className="text-orange-400 hover:text-orange-300 hover:underline" to="/app/device_manager">Meus dispositivos</Link>
                            </li>
                        </ul>
                    </div>
                </>
            )}
        </div>
    )
}

export default Ativar;